export const actionTypes = {
  SWITCH_TO_UZBEK: "SWITCH_TO_UZBEK",
  SWITCH_TO_RUSSIAN: "SWITCH_TO_RUSSIAN",
  SWITCH_TO_ENGLISH: "SWITCH_TO_ENGLISH",
  SWITCH_LANG: "SWITCH_LANG",
};

export default actionTypes;
